const DEFAULT_API_BASE_URL = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5050';
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL).replace(/\/$/, '');

export const PARTICIPANT_SESSION_KEY = 'diting_participant_session_v2';
export const PARTICIPANT_AUTH_TOKEN_KEY = 'diting_participant_auth_token_v2';
export const PARTICIPANT_ACCOUNT_KEY = 'diting_participant_account_v2';
export const ADMIN_TOKEN_KEY = 'diting_admin_token_v2';

function participantHeaders() {
  const token = localStorage.getItem(PARTICIPANT_AUTH_TOKEN_KEY);
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function request(path, options = {}, auth = 'none') {
  const adminToken = localStorage.getItem(ADMIN_TOKEN_KEY);
  const headers = {
    ...(options.body ? { 'Content-Type': 'application/json' } : {}),
    ...(auth === 'participant' ? participantHeaders() : {}),
    ...(auth === 'admin' && adminToken ? { Authorization: `Bearer ${adminToken}` } : {}),
    ...(options.headers || {}),
  };
  const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload?.error?.message || '请求失败，请稍后重试');
    error.code = payload?.error?.code;
    error.status = response.status;
    throw error;
  }
  return payload;
}

export function loadParticipantSession() {
  try {
    return JSON.parse(localStorage.getItem(PARTICIPANT_SESSION_KEY) || 'null');
  } catch {
    return null;
  }
}

export function saveParticipantSession(session) {
  localStorage.setItem(PARTICIPANT_SESSION_KEY, JSON.stringify(session));
}

export function clearParticipantSession() {
  localStorage.removeItem(PARTICIPANT_SESSION_KEY);
}

export function loadParticipantAccount() {
  try {
    return JSON.parse(localStorage.getItem(PARTICIPANT_ACCOUNT_KEY) || 'null');
  } catch {
    return null;
  }
}

export function saveParticipantAccount(account) {
  localStorage.setItem(PARTICIPANT_ACCOUNT_KEY, JSON.stringify(account));
}

export function saveParticipantAuth({ token, account, session }) {
  localStorage.setItem(PARTICIPANT_AUTH_TOKEN_KEY, token);
  saveParticipantAccount(account);
  if (session) saveParticipantSession(session);
  else clearParticipantSession();
}

export function clearParticipantAuth() {
  localStorage.removeItem(PARTICIPANT_AUTH_TOKEN_KEY);
  localStorage.removeItem(PARTICIPANT_ACCOUNT_KEY);
  clearParticipantSession();
}

export const api = {
  register: (credentials) => request('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify(credentials),
  }),
  login: (credentials) => request('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  }),
  me: () => request('/api/auth/me', {}, 'participant'),
  start: (profile) => request('/api/start', {
    method: 'POST',
    body: JSON.stringify(profile),
  }, 'participant'),
  state: () => request('/api/state', {}, 'participant'),
  clickAi: (taskId) => request('/api/ai-click', {
    method: 'POST',
    body: JSON.stringify({ taskId }),
  }, 'participant'),
  answerComprehension: (taskId, answerIndex) => request('/api/comprehension', {
    method: 'POST',
    body: JSON.stringify({ taskId, answerIndex }),
  }, 'participant'),
  copyCandidate: (taskId, candidateId) => request('/api/candidate-copy', {
    method: 'POST',
    body: JSON.stringify({ taskId, candidateId }),
  }, 'participant'),
  saveResponse: (payload) => request('/api/response', {
    method: 'POST',
    body: JSON.stringify(payload),
  }, 'participant'),
  saveSurvey: (payload) => request('/api/survey', {
    method: 'POST',
    body: JSON.stringify(payload),
  }, 'participant'),
  complete: () => request('/api/complete', { method: 'POST' }, 'participant'),
  adminLogin: (credentials) => request('/api/admin/login', {
    method: 'POST',
    body: JSON.stringify(credentials),
  }),
  adminSummary: () => request('/api/admin/summary', {}, 'admin'),
  adminParticipants: () => request('/api/admin/participants', {}, 'admin'),
  adminSettings: () => request('/api/admin/settings', {}, 'admin'),
  updateAdminSettings: (settings) => request('/api/admin/settings', {
    method: 'PUT',
    body: JSON.stringify(settings),
  }, 'admin'),
  downloadExport: async (name) => {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    const response = await fetch(`${API_BASE_URL}/api/export/${encodeURIComponent(name)}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!response.ok) throw new Error('数据导出失败');
    return response.blob();
  },
};

export function getApiErrorMessage(error, fallback = '无法连接本地服务，请确认后端已经启动。') {
  return error?.message || fallback;
}
